// extracted by mini-css-extract-plugin
export default {"imgWidths":"service_imgWidths__XtpsI"};